import xssFilter from 'xssfilter';
import _get from 'lodash/get';
import * as types from '../constants/actionTypes';
import isNode from '../modules/ajio-util/isNode';
import { showLoader, hideLoader } from './loader';
import { showModal, hideModal, updateModal } from './modal.js';
import { getMinicartData } from './addProductToCart';
import { readCookie } from '../components/common/Cookie.js';
import { Cookies } from '../constants';

import {
  resetDeliveryDetails,
  fetchDeliveryDetails,
  setPincodeModal
} from '../edd/actions/index.js';
import { setExpiresTime } from './shared/expires';
import { getExpiresFromResponse } from '../utils';
import fetcher from '../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getFetcherHeader,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../modules/ajio-fetch/utils';
import properties from '../modules/ajio-util/properties';
import { getHostName } from '../utils/sisUtils';
import { gtmEventPush } from '../modules/ga/GTMdatalayer';
import screenNames from '../refresh/constants/luxeScreenType';
import { getSearchExpFlags } from '../utils/products';
import {
  getSearchFlags,
  getUrgencyDriverV2Config
} from '../refresh/selectors/featureFlagsSelector';
import {getAmplitudeVariantPayload,  getAmplitudeVariantFlag, getAmplitudeVariantPayloadMap } from '../utils/amplitudeCommon';

import qs from 'qs';

const endpoints = require('../modules/ajio-util/endpoints');

const xssfilter = new xssFilter();

// Get specific cookie name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length == 2) {
    return parts
      .pop()
      .split(';')
      .shift();
  }
  return undefined;
}

// sizeGuide data
function fetchSizeDataUrl(productObj, pageType) {
  const {
    application = ' ',
    brick = ' ',
    brand = ' ',
    vendor = ' ',
    fit = ' ',
    style = ' ',
    server = false,
    url: URL = '',
    productCode = '',
    seasonCode = '',
    gender = '',
    subCategory = '',
    headerInfo = {},
    baseProduct = ''
  } = productObj;
  // application='RILFNL-AJIO', brick='830216001', brand='ajio', vendor = " ", fit = " ", style = " ";

  let url = '';

  if (pageType == 'wishlist') {
    url = encodeURI(`/api/p/sizedata/${application}/${brick}/${brand}/${vendor}/${fit}/${style}`);
    return fetcher(url, fetchGetJSONReqOpts(headerConfig));
  }
  url = encodeURI(
    `/api/p/sizedata/${application}/${brick}/${brand}/${vendor}/${fit}/${style}?optionCode=${baseProduct}&productCode=${productCode}&seasonCode=${seasonCode}&gender=${gender}&subCategory=${subCategory}`
  );
  const headerConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      ...headerInfo
    }
  };
  if (server && URL.length > 0) {
    const timeout = _get(global, '__SIZEGUIDE_TIMEOUT__', 2000);
    url = URL;
    headerConfig.timeout = timeout;
  }
  return fetcher(url, fetchGetJSONReqOpts(headerConfig));
}

function fetchSizeData(sizeData) {
  return {
    type: 'FETCH_SIZE_DATA',
    sizeData
  };
}

export function getSizeData(productObj, pageType = '') {
  return function(dispatch) {
    return fetchSizeDataUrl(productObj, pageType)
      .then(response => {
        if (response.ok) {
          return response.json().then(json => {
            dispatch(fetchSizeData(json));
          });
        }
      })
      .catch(error => {});
    // dispatch(fetchSizeData(data));
  };
}

function fetchSizeRecommendUrl(getHttpMethodParameter) {
  const {
    application = ' ',
    brick = ' ',
    brand = ' ',
    vendor = ' ',
    fit = ' ',
    style = ' ',
    server = false,
    url: URL = '',
    productCode = ' ',
    seasonCode = ' ',
    gender = ' ',
    subCategory = ' '
  } = getHttpMethodParameter;

  // let url = encodeURI(`http://10.21.79.36:8080/sizechart/recommendUserSize?applicationName=${application}&customerId=${getCookie('CI')}&productCode=${productCode}&brickCode=${brick}&brandCode=${brand}&fittingType=${fit}&vendorCode=${vendor}&seasonCode=${seasonCode}&styleType=${style}`);
  let url = encodeURI(
    `/api/p/sizechart/recommendUserSize/${application}/${getCookie(
      'CI'
    )}/${productCode}/${brick}/${brand}/${fit}/${vendor}/${seasonCode}/${style}`
  );
  // let url = encodeURI(`/sizechart/recommendUserSize?applicationName=${application}&customerId=${getCookie('CI')}&productCode=${productCode}&brickCode=${brick}&brandCode=${brand}&fittingType=${fit}&vendorCode=${vendor}&seasonCode=${seasonCode}&styleType=${style}`);
  const headerConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  };
  if (server && URL.length > 0) {
    const timeout = _get(global, '__SIZEGUIDE_TIMEOUT__', 2000);
    url = URL;
    headerConfig.timeout = timeout;
  }

  return fetcher(url, fetchGetJSONReqOpts(headerConfig));
}
function fetchUserSizeGuidePopUp(getHttpMethodParameter) {
  const {
    application = ' ',
    brick = ' ',
    brand = ' ',
    vendor = ' ',
    fit = ' ',
    style = ' ',
    server = false,
    url: URL = '',
    productCode = ' ',
    seasonCode = ' ',
    gender = ' ',
    subCategory = ' '
  } = getHttpMethodParameter;

  let url;
  const headerConfig = {};
  if (server && URL.length > 0) {
    url = URL;
    const timeout = _get(global, '__SIZEGUIDE_TIMEOUT__', 2000);
    headerConfig.timeout = timeout;
  } else {
    url = encodeURI(
      `/api/p/sizechart/fetchUserSizeGuide/${application}/${getCookie(
        'CI'
      )}/${productCode}/${brick}/${brand}/${fit}/${vendor}/${seasonCode}/${style}/${gender}/${subCategory}`
    );
  }
  return fetcher(url, fetchGetJSONReqOpts(headerConfig));
}

function fetchSizeRecommendData(sizeRecommendData) {
  return {
    type: 'FETCH_SIZE_RECOMMEND',
    sizeRecommendData
  };
}
function fetchUserSizeGuidePopUpData(
  sizeRecommendPopUpData,
  recommendDataVariant = '0',
  device = ''
) {
  const { purchasedOrdersData = [] } = sizeRecommendPopUpData;
  const { sizeGuide: { screenName = '', screenType = '' } = {}, defaultStore = '' } = screenNames;
  return {
    type: 'FETCH_SIZE_RECOMMEND_POP_UP',
    sizeRecommendPopUpData
  };
}

function gaSizeRecomendationCall(req, res) {
  if (isNode()) {
    return;
  }
  const { productCode = '' } = req;
  const { recommendedSizeName = '' } = res;
  const CustomerID = getCookie('CI');
  window.ga &&
    window.ga('send', {
      eventCategory: 'bannerimpressions',
      eventAction: 'PDP Size recommendations call',
      eventLabel: `Size_Reco_${CustomerID}_${productCode}_${recommendedSizeName}`
    });
}

export function getSizeRecommend(getHttpMethodParameter, device) {
  const { recommendDataVariant = '0' } = getHttpMethodParameter;
  return function(dispatch) {
    return fetchSizeRecommendUrl(getHttpMethodParameter)
      .then(response => {
        if (response.ok) {
          return response.json().then(json => {
            dispatch(fetchSizeRecommendData(json));
            if (json.sizeName) {
              fetchUserSizeGuidePopUp(getHttpMethodParameter)
                .then(response => response.json())
                .then(json => {
                  gaSizeRecomendationCall(getHttpMethodParameter, json);
                  dispatch(fetchUserSizeGuidePopUpData(json, recommendDataVariant, device));
                });
            } else {
              dispatch(fetchUserSizeGuidePopUpData({}, recommendDataVariant, device));
            }
          });
        }
      })
      .catch(error => {});
  };
}

export function fetchUserSizeGuidePopUpAndroid(getHttpMethodParameter) {
  return function(dispatch) {
    return fetchUserSizeGuidePopUp(getHttpMethodParameter)
      .then(response => response.json())
      .then((json = {}) => {
        if (json.purchasedOrdersData) {
          dispatch(fetchUserSizeGuidePopUpData(json));
        }
      })
      .catch(error => {});
  };
}

function fetchURL(productID) {
  const url = `/api/p/${productID}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function getProductDetailsResponse(product) {
  return {
    type: 'FETCH_PRODUCT_DATA',
    product
  };
}

export function getProductDetails(productID) {
  return function(dispatch) {
    return fetchURL(productID).then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(getProductDetailsResponse(json));
        });
      }
    });
  };
}

// Similar Styles
function fetchSimilarData(productID, req, ABFlagObj, urgencyDriverV2MsiteConfig = {}, filters) {
  if (isNode()) {
    const { device: { client_type = '' } = {}, store = '' } = req;
    const Host = req.hostname;
    const StoreValue = getHostName(Host);
    const storeval = req.store || StoreValue;
    const channelType = req.device.type === 'phone' ? 'MSITE' : 'WEB';

    let apiEndPoint = `${endpoints.get(
      'recommend'
    )}/${productID}?fields=FULL&format=json&client_type=${client_type}&${qs.stringify({
      ...ABFlagObj
    })}`;
    if (storeval) {
      apiEndPoint = `${apiEndPoint}&store=${storeval}`;
    }

    if (filters) {
      apiEndPoint += `&filters=${filters}`;
    }

    // NOTE: FOR URGENCY DRIVER V2
    const { enableMaster = 'OFF', plpPage = {} } = urgencyDriverV2MsiteConfig || {};
    const { enable: enablePlpPage = 'OFF', experimentName = '' } = plpPage || {};
    let headerInfo = {};
    const enablePlpUrgencyDriverV2 =
      enableMaster === 'ON' && enablePlpPage === 'ON' && experimentName && channelType === 'MSITE';

    if (enablePlpUrgencyDriverV2) {
      apiEndPoint = `${apiEndPoint}&tagV2Enabled=true&tagExperiment=${experimentName}`;
      headerInfo = {
        ...headerInfo,
        'X-TENANT-ID': 'AJIO'
      };
    }

    return fetcher(apiEndPoint, fetchGetJSONReqOpts({ headers: { ...headerInfo } }));
  }
  let url = `/api/p/similar/${productID}?SearchExperimentFlag=${JSON.stringify(ABFlagObj)}`;
  if (filters) {
    url += `&filters=${filters}`;
  }
  return fetcher(url, fetchGetJSONReqOpts());
}

function getSimilarDetails(similarData) {
  return {
    type: 'FETCH_SIMILAR_DATA',
    similarData
  };
}

export function getSimilarStyles(productID, req, filters) {
  return function(dispatch, getState) {
    const states = getState();

    const flags = getAmplitudeVariantPayload('searchExpFlags',states, getSearchFlags(states));
    let ABFlagObj = (states?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(flags, states) : getSearchExpFlags(flags);
    const urgencyDriverV2MsiteConfig = getUrgencyDriverV2Config(states);

    return fetchSimilarData(productID, req, ABFlagObj, urgencyDriverV2MsiteConfig, filters).then(
      response => {
        if (response.ok) {
          response.json().then(json => {
            dispatch(getSimilarDetails(json));
          });
        }
      }
    );
  };
}

function fetchCrossSellData(crossSellObj, req) {
  const { productCode = '', brick = '' } = crossSellObj;
  const url = `/api/p/recommendation/${productCode}/${brick}`;
  return fetcher(url, fetchGetJSONReqOpts())
    .then(response => {
      return response;
    })
    .catch(error => {});
}

function getCrossSellDetails(crossSellData) {
  return {
    type: 'FETCH_CROSS_SELL_DATA',
    crossSellData
  };
}

export function getCrossSell(crossSellObj, req) {
  return function(dispatch, getState) {
    const states = getState();
    return fetchCrossSellData(crossSellObj, req)
      .then(fetchGetJSONResHandler)
      .then(resp => {
        dispatch(getCrossSellDetails(resp || []));
      })
      .catch(err => {
        dispatch(getCrossSellDetails([]));
        console.log('err: ', err);
      });
  };
}

// Shop the capsule
function fetchCapsuleUrl(productID) {
  const url = `/api/p/capsules/${productID}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function getCapsuleDetails(capsules) {
  return {
    type: 'FETCH_CAPSULES_DATA',
    capsules
  };
}

export function getCapsulesData(productID) {
  return function(dispatch) {
    return fetchCapsuleUrl(productID).then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(getCapsuleDetails(json));
        });
      }
    });
  };
}
function sizeSelection(sizeName, sizeCode, stockLevel, discountPrice, originalPrice, cartOrNot) {
  return {
    type: 'SELECT_SIZE',
    selectedSizeName: sizeName,
    selectedSizeCode: sizeCode,
    selectedSizeStockLevel: stockLevel,
    discountPrice,
    originalPrice,
    cartOrNot
  };
}
export function dodSizeSelection(size) {
  return {
    type: 'DOD_SIZE_CHANGE',
    dodSize: size
  };
}

function cartReset() {
  return {
    type: 'RESET_CART_ITEM'
  };
}

// Selected size code
export function selectSize(
  sizeName,
  sizeCode,
  stockLevel,
  discountPrice,
  originalPrice,
  cartOrNot
) {
  return function(dispatch) {
    Promise.resolve(
      dispatch(
        sizeSelection(sizeName, sizeCode, stockLevel, discountPrice, originalPrice, cartOrNot)
      )
    ).then(() => {
      dispatch(resetDeliveryDetails(sizeCode));
      if (!sizeCode) {
        return;
      }
      if (readCookie(Cookies.PINCODE)) {
        dispatch(fetchDeliveryDetails()).then(({ pinCode, servicability }) => {
          if (servicability === false) {
            window.ga &&
              window.ga('send', {
                hitType: 'event',
                eventCategory: 'buttonTap',
                eventAction: 'EDD on PDP',
                eventLabel: `Delivery not available message - ${pinCode}`
              });
          }
        });
      }
    });
    dispatch(cartReset());
  };
}

// Select size quickview
export function selectSizeQuickview(sizeName, sizeCode, stockLevel, discountPrice, originalPrice) {
  return {
    type: 'QUICKVIEW_SELECT_SIZE',
    selectedSizeName: sizeName,
    selectedSizeCode: sizeCode,
    selectedSizeStockLevel: stockLevel,
    discountPrice,
    originalPrice
  };
}

// Select size error
export function selectSizeErrorQuickview(message) {
  return {
    type: 'QUICKVIEW_SELECT_SIZE_ERROR_MESSAGE',
    size_error: message
  };
}

// Select size error
export function selectSizeError(message) {
  return {
    type: 'SELECT_SIZE_ERROR_MESSAGE',
    size_error: message
  };
}

export function selectNotifyError(message) {
  return {
    type: 'SELECT_NOTIFY_MESSAGE',
    size_error: message
  };
}

// Put Recent items
export function putRecentProducts(productID) {
  return {
    type: 'PUT_RECENT_PRODUCTS',
    recent: productID
  };
}

// Fetch Recently Viewed Products
function fetchRecentlyViewedUrl(productID, ABFlagObj) {
  const url = `/api/p/recentlyViewed/${productID}?SearchExperimentFlag=${JSON.stringify(
    ABFlagObj
  )}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function getRecentlyViewedData(recentlyViewed) {
  return {
    type: 'FETCH_RECENT_DATA',
    recentlyViewed
  };
}

export function getRecentlyViewed(productID) {
  if (productID.length) {
    return function(dispatch, getState) {
      const states = getState();

    const flags = getAmplitudeVariantPayload('searchExpFlags',states, getSearchFlags(states));
    

    let ABFlagObj = (states?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(flags, states) : getSearchExpFlags(flags);
       

      return fetchRecentlyViewedUrl(productID, ABFlagObj).then(
        response => {
          if (response.ok) {
            response.json().then(json => {
              dispatch(getRecentlyViewedData(json));
            });
          }
        }
      );
    };
  }
}

// Ensamble
function fetchEnsambleUrl(productID) {
  const url = `/api/p/ensamble/${productID}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function getEnsambleData(ensamble) {
  return {
    type: 'FETCH_ENSAMBLE_DATA',
    ensamble
  };
}

export function getEnsamble(productID) {
  return function(dispatch) {
    return fetchEnsambleUrl(productID).then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(getEnsambleData(json));
        });
      }
    });
  };
}

// Slick selected image id
const selectById = id => ({
  type: 'SELECT_BY_ID',
  payload: id
});

export function onSelectById(id) {
  return {
    type: 'SELECT_BY_ID',
    payload: id
  };
}

// Slick reset selected image id
const resetSelectedImage = id => ({
  type: 'RESET_IMAGE_SELECTED'
});

export function resetImageSelection(id) {
  return function(dispatch) {
    return dispatch(resetSelectedImage(id));
  };
}

const resetSelectedSize = () => ({
  type: 'RESET_SIZE_SELECTED'
});

const resetQCSizeErr = () => ({
  type: 'RESET_QC_ERROR'
});

// Empty data
const emptyProductDetails = id => ({
  type: 'EMPTY_PRODUCT_DETAILS',
  flag: id
});

export function emptyProductData(id) {
  return function(dispatch) {
    return dispatch(emptyProductDetails(id));
  };
}

function addItemsToTheCart(productID) {
  let bodyStr = '';
  bodyStr += `qty=${encodeURIComponent(1)}`;
  bodyStr += `&productCodePost=${encodeURIComponent(productID)}`;
  return fetcher(
    '/cart/add?site=rilfnl',
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        Accept: '*',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        credentials: 'include',
        Cache: 'no-cache'
      },
      credentials: 'include',
      body: bodyStr
    })
  );
}

function updateItemsInTheCart(entry, productId, qty) {
  let bodyStr = '';
  bodyStr += `entryNumber=${encodeURIComponent(entry)}`;
  bodyStr += `&productCodeMini=${encodeURIComponent(productId)}`;
  bodyStr += `&initialQuantityMini=${encodeURIComponent(0)}`;
  bodyStr += `&quantity=${encodeURIComponent(0)}`;
  return fetcher(
    '/cart/remove?site=rilfnl',
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        Accept: '*',
        'Content-Type': 'application/x-www-form-urlencoded',
        credentials: 'include',
        Cache: 'no-cache'
      },
      credentials: 'include',
      body: bodyStr
    })
  );
}

function hideMinicart() {
  return {
    type: 'HIDE_MINICART'
  };
}

export function removeCartProduct(entry, productId, qty) {
  return function(dispatch) {
    dispatch(showLoader('quick-view-loader'));
    return updateItemsInTheCart(entry, productId, qty)
      .then(response => {
        dispatch(hideLoader('quick-view-loader'));
        dispatch(hideMinicart());
      })
      .catch(err => {
        console.log(`err : ${err}`);
      });
  };
}

export function putMinicartData(miniCartData) {
  return {
    type: 'MINICART_DATA',
    miniCartData
  };
}

export function closeAllMessage() {
  return {
    type: 'CLOSE_ALL_POPUP'
  };
}

export function addedToCart(showCart) {
  return {
    type: 'SHOW_CART_POPUP',
    showCartPopup: showCart
  };
}

export function addedToCartMembership() {
  return {
    type: 'SHOW_CART_MEMBERSHIP'
  };
}

export function displayMinicart() {
  return function(dispatch) {
    dispatch(getMinicartData());
  };
}

// Open Modal
function quickviewUrl(productID) {
  const url = `/api/p/${productID}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

export function openModal(id) {
  return function(dispatch) {
    dispatch(showLoader('quick-view-loader'));
    return quickviewUrl(id).then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(hideLoader('quick-view-loader'));
          dispatch(resetSelectedImage(id));
          dispatch(resetSelectedSize());
          dispatch(resetQCSizeErr());
          dispatch(showModal('quickview-modal', { state: { product: json } }));
        });
      }
    });
  };
}

// Color Swatch quickviewUrl
function colorSwatchUrl(productID) {
  const url = `/api/p/${productID}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

export function onSelectColor(id) {
  return function(dispatch) {
    return colorSwatchUrl(id).then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(updateModal('quickview-modal', { state: { product: json } }));
        });
      }
    });
  };
}

// Pincode
function pincodeUrl(productID, pincode) {
  const url = `/api/p/pincodecheck/${productID}/${xssfilter.filter(pincode)}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

const pincodeUpdate = pincode => ({
  type: 'SET_PINCODE',
  pincode
});

export function setPincode(id, pid) {
  return function(dispatch) {
    return pincodeUrl(id, pid)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(json => {
        dispatch(pincodeUpdate(json));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

// NOTE: FOR PDP TO BAG CONVERSION - RELEVANT PRODUCTS WIDGET
function fetchRelevantProductsWidgetApi(baseProductInfo) {
  const {
    brandName = '',
    brickName = '',
    productCategory = '',
    productTags = [],
    previousSource=''
  } = baseProductInfo;
  const tagOrder = ['Best Seller', 'Selling Fast', 'Best Price', 'New', 'Exclusive'];
  const priorityTag =
    tagOrder
      .map(el => {
        if (productTags.find(cur => (cur?.primary?.value ?? '').toLowerCase() === el.toLowerCase()))
          return el;

        return '';
      })
      .filter(el => el)?.[0] ?? '';
  const l1l3nestedcategory = `${productCategory} - ${brickName}`;
  const tag = `${priorityTag.charAt(0).toUpperCase()}${priorityTag.slice(1).toLowerCase()}`.replace(
    ' ',
    ''
  );
  const url = `/api/p/releventProducts?genderfilter=${encodeURIComponent(
    productCategory
  )}&l1l3nestedcategory=${encodeURIComponent(l1l3nestedcategory)}&tags=${encodeURIComponent(
    tag
  )}&brandName=${brandName}&previousSource=${previousSource}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

const fetchRelevantProductsWidgetDataSuccess = response => {
  return {
    type: 'FETCH_RELEVANT_PRODUCTS_WIDGET_SUCCESS',
    payload: response
  };
};

export function getRelevantProductsWidgetData(baseProductInfo) {
  return (dispatch) => {
    return fetchRelevantProductsWidgetApi(baseProductInfo)
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(fetchRelevantProductsWidgetDataSuccess(response));
      })
      .catch(error => {
        console.debug(error);
      });
  };
}


export function getAjioWalletDataPDP(requestObj = {}) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  const { device: { client_type = '' } = {}, store = '' } = request;
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    const headerInfo = getFetcherHeader(request);
    let url = properties.getProperty('apiUrl');
    let rilwebserviceUrl = '/rilfnlwebservices/v2/rilfnl';
    const userName = request.cookies.U;
    const token = request.cookies.A;
    apiEndPoint = `${url}${rilwebserviceUrl}/users/${userName}/ajiocash/walletbalance?fields=FULL&client_type=${client_type}`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({ headers: { Authorization: `Bearer ${token}`, ...headerInfo } })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch({ type: 'SET_AJIOWALLET_DATA_BOTTOMSTRIP', payload: { ajioWalletData : response } });
        dispatch({ type: 'GET_AJIOWALLET_DATA_SUCCESS_BOTTOMSTRIP'});
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getAjioWalletDataPDP(requestObj)(dispatch);
            });
          }
        dispatch({ type: 'GET_AJIOWALLET_DATA_FAIL_BOTTOMSTRIP'});
        });
      });
  };
}